import { ICON_TYPES } from '../constants';

export const Expand = () => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6936_857)">
        <path
          d="M12 4.5V1.5C12 1.23478 11.8946 0.98043 11.7071 0.792893C11.5196 0.605357 11.2652 0.5 11 0.5H8V1.5H10.293L6 5.793L1.707 1.5H4V0.5H1C0.734784 0.5 0.48043 0.605357 0.292893 0.792893C0.105357 0.98043 0 1.23478 0 1.5L0 4.5H1V2.207L5.293 6.5L1 10.793V8.5H0V11.5C0 11.7652 0.105357 12.0196 0.292893 12.2071C0.48043 12.3946 0.734784 12.5 1 12.5H4V11.5H1.707L6 7.207L10.293 11.5H8V12.5H11C11.2652 12.5 11.5196 12.3946 11.7071 12.2071C11.8946 12.0196 12 11.7652 12 11.5V8.5H11V10.793L6.707 6.5L11 2.207V4.5H12Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_6936_857">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

Expand.iconType = ICON_TYPES.EXPAND;
